module.exports = __webpack_public_path__ + "static/media/aq.b95845ac.svg";